import ApiService from "@/common/api/api.service";

let endpoint = "Projeto";

const CronogramaEtapa = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    buscarInvestimentos(idProjeto, rubrica, nomeIdProjeto = "ProjetoId") {
        return ApiService.get(`${endpoint}/${rubrica}?${nomeIdProjeto}=${idProjeto}`);
    },
    buscarInvestimentosExecutora(idProjeto, rubrica) {
        return ApiService.get(`Projeto/${rubrica}?projetoId=${idProjeto}`);
    },

    salvarInvestimento(form, rubrica){
        return ApiService.put(`${endpoint}/${rubrica}`, form);
    }
}

export default CronogramaEtapa;
